"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArduinoSimulator = void 0;
const ArduinoGlobals_1 = require("./ArduinoGlobals");
const Adafruit_NeoPixel_1 = require("../ArduinoLibraryClones/Adafruit_NeoPixel");
const VirtualMatrix_1 = require("../LedMatrixSimulator/VirtualMatrix");
class ArduinoSimulator {
    constructor(program) {
        this._program = program;
        this._requestCancellation = false;
        this._cancelled = false;
    }
    execute(maxIterations = -1) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("Executing fake Arduino code");
            this._requestCancellation = false;
            this._cancelled = false;
            yield this._program.setup();
            let programCounter = 0;
            while (true) {
                if (this._requestCancellation) {
                    this._cancelled = true;
                    console.log("Stopping fake Arduino code");
                    return;
                }
                yield this._program.loop();
                yield ArduinoGlobals_1.delay(1);
                programCounter++;
                if (maxIterations == -1) {
                    continue;
                }
                if (maxIterations > -1 && programCounter >= maxIterations) {
                    return;
                }
            }
        });
    }
    stop() {
        return __awaiter(this, void 0, void 0, function* () {
            this._requestCancellation = true;
            while (!this._cancelled) {
                yield ArduinoGlobals_1.delay(5);
            }
            this._requestCancellation = false;
            this._cancelled = false;
        });
    }
    static runWithDisplay(program, displayTarget, displayConfig) {
        const leds = new VirtualMatrix_1.VirtualMatrix(displayTarget, displayConfig);
        ArduinoSimulator.run(program, leds);
    }
    static run(program, virtualLedMatrix = null) {
        const sim = new ArduinoSimulator(program);
        if (virtualLedMatrix) {
            Adafruit_NeoPixel_1.Adafruit_NeoPixel.setLedStrip(virtualLedMatrix);
        }
        sim.execute();
    }
}
exports.ArduinoSimulator = ArduinoSimulator;
//# sourceMappingURL=ArduinoSimulator.js.map